import Bugsnag from "@/lib/bugsnag";
import { supabase } from "@/lib/supabase";

import { ADJECTIVES, COLORS, NOUNS } from "./slug-list";

export function generateEffSlug(): string {
  const randomValues = crypto.getRandomValues(new Uint16Array(3));
  const adjective = ADJECTIVES[randomValues[0] % ADJECTIVES.length];
  const color = COLORS[randomValues[1] % COLORS.length];
  const noun = NOUNS[randomValues[2] % NOUNS.length];
  return `${adjective}-${color}-${noun}`;
}

export async function generateUniqueSlug(): Promise<string> {
  for (let attempt = 0; attempt < 10; attempt++) {
    const slug = generateEffSlug();
    const { data } = await supabase
      .from("event")
      .select("id")
      .eq("slug", slug)
      .maybeSingle();

    if (!data) {
      if (attempt >= 3) {
        Bugsnag.notify(
          new Error(
            `Slug generation required ${attempt + 1} attempts before finding a unique slug`,
          ),
        );
      }
      return slug;
    }
  }

  throw new Error("Failed to generate a unique slug after 10 attempts");
}
